import {
  NonSyariahBadgeWrapper,
  NonSyariahBadgeLabel,
} from '../components.styled';

interface NonSyariahBannerProps {
  label: string;
  noMargin?: boolean;
}

export default function NonSyariahBadge({
  label,
  noMargin,
}: NonSyariahBannerProps) {
  return (
    <NonSyariahBadgeWrapper noMargin={noMargin}>
      <NonSyariahBadgeLabel>{label}</NonSyariahBadgeLabel>
    </NonSyariahBadgeWrapper>
  );
}
